import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Search, MapPin } from "lucide-react";
import Money from "@/components/Money";

export default function SearchTile({ s }) {
  const name = s.signer_name || s.signer_name_masked || "—";
  return (
    <Link to={`/searches/${s.id}`} data-testid={`marketplace-search-${s.id}`} className="block">
      <Card
        className="bg-[#FFFAF0] border-[#D8CFBB] rounded-lg p-5 hover:border-[#C5A880] hover:-translate-y-0.5 transition-all duration-200 cursor-pointer h-full"
      >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Search className="h-4 w-4 text-[#C5A880]" />
          <p className="text-sm text-[#1A1610] font-medium">{name}</p>
        </div>
        <Badge className="bg-emerald-700 text-white text-[10px]">ACTIVE</Badge>
      </div>
      <p className="text-xs text-[#7A6E5A] mb-1 flex items-center gap-1">
        <MapPin className="h-3 w-3" /> {s.search_area || "—"}
      </p>
      <Money value={s.search_budget} className="text-lg text-[#C5A880]" />
      <p className="text-[11px] text-[#9A8B72] mt-3 font-mono">{new Date(s.created_at).toLocaleDateString()}</p>
    </Card>
    </Link>
  );
}
